import { PreparedWorkload } from 'features/workload-optimization';

import { ClientSideSearchCriterion } from '@cast/shared-search-ui';

export const namespaceCriterion: ClientSideSearchCriterion<PreparedWorkload> = {
  key: 'namespace',
  prop: 'namespace',
  matcher: 'exact',
};

export const kindCriterion: ClientSideSearchCriterion<PreparedWorkload> = {
  key: 'kind',
  prop: 'kind',
  matcher: 'exact',
};
